import PropTypes from 'prop-types';
import React from 'react';

import * as items from './items/index';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @component ItemDispatcher
 * @props (see propTypes)
 */
const ItemDispatcher = ({
    alternate = null,
    item      = null,
    namespace,
}) => {
    if (!item?.__typename) { return null; }

    const itemKey = Object.keys(items).find((key) => items[key].__typename === item.__typename);

    if (!itemKey) { return; }

    const ItemComponent = items[itemKey];

    return (
        <ItemComponent
            alternate={alternate}
            namespace={namespace}
            {...item} />
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

ItemDispatcher.propTypes = {
    alternate: PropTypes.bool,
    item:      PropTypes.object.isRequired,
    namespace: PropTypes.string
};

export default ItemDispatcher;
